export type SaleDiscount = {
    id: number;
    name: string;
    amount: number;
    isPercentage: boolean;
}

export const DefaultSaleDiscount: SaleDiscount = {
    id: 0,
    name: '',
    amount: 0,
    isPercentage: false
}